export const HKM = {
  language_code: "km",
  get_btn: "ទទួលបានឥឡូវនេះ",
  unregistered_tip: "អ្នកប្រើប្រាស់ដែលមិនបានចុះឈ្មោះនឹងបង្កើតគណនីដោយផ្ទាល់",
  phone_number: "លេខទូរស័ព្ទ",
  ver_code: "លេខកូដបញ្ជាក់",
  get_ver_code: "ទទួលលេខកូដ",
  retrieve_ver_code: "ផ្ញើម្ដងទៀត ({SECONDS})",
  age_tip: "ខ្ញុំមានអាយុបរិភោគពេញ និងមានសមត្ថភាពស៊ីវិលពេញលេញ ហើយយល់ព្រម ",
  and: "និង",
  PRIVICY_POLICY: '"គោលនយោបាយភាពឯកជន"',
  MEMBER_AGGREMENT: '"លក្ខខណ្ឌសមាជិក"',
  agree_push:
    "أوافق على تلقي إشعارات من هايديلاؤ عبر رقم الهاتف أو البريد الإلكتروني المسجل.",
  CN: "ចិន",
  US: "សហរដ្ឋអាមេរិក",
  CA: "កាណាដា",
  GB: "ចក្រភពអង់គ្លេស",
  MY: "ម៉ាឡេស៊ី",
  AU: "អូស្ត្រាលី",
  ID: "ឥណ្ឌូនេស៊ី",
  SG: "សិង្ហបុរី",
  TH: "ថៃ",
  JP: "ជប៉ុន",
  KR: "កូរ៉េ",
  VN: "វៀតណាម",
  HK: "ហុងកុង",
  MO: "ម៉ាកាវ",
  HKM: "កម្ពុជា",
  TW: "តៃវ៉ាន់",
  PH: "ហ្វីលីពីន",
  UAE: "អារ៉ាប់រួម",
  suc_send: "ផ្ញើបានជោគជ័យ",
  suc_get: "تم الاستلام بنجاح",
  fail_ver_code: "លេខកូដមិនត្រឹមត្រូវ",
  time_end: "ព្រឹត្តិការណ៍បានបញ្ចប់",
  not_get_repeat: "មិនអាចទទួលជាថ្មីបានទេ!",
  not_get_eligible: "មិនអាចទទួលបាន ទំនងមិនត្រូវលក្ខខណ្ឌកម្មវិធី",
  not_get_late: "អ្នកស្ទាក់បន្តិច ព្រឹត្តិការណ៍បានបញ្ចប់",
  get_coupon: "ទទួលបានគូប៉ុង",
  phone_err: "رقم الهاتف غير صحيح. يرجى إدخال رقم صحيح.",
  page_title: "ទទួលបានគូប៉ុងពិសេស Haidilao",
  send_code_error: "បញ្ហាក្នុងការផ្ញើកូដផ្ទៀងផ្ទាត់",
  network_error:
    "ការតភ្ជាប់អ៊ីនធឺណិតរបស់អ្នកមិនស្ថិតស្ថាបនាឡើយ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។",
  member_status_abnormal: "គណនីសមាជិកមានបញ្ហា មិនអាចទទួលបានទេ",
  send_frequently:
    "កូដផ្ទៀងផ្ទាត់ត្រូវបានផ្ញើច្រើនពេក។ សូមបញ្ចូលកូដចុងក្រោយដែលអ្នកបានទទួល ឬសាកល្បងម្តងទៀតនៅពេលក្រោយ។",
  activity_boom: "អ្នកដកយកច្រើនពេក សូមសាកល្បងម្តងទៀត",
  email: "អ៊ីមែល",
  email_error_tip: "البريد الإلكتروني غير صحيح. يرجى إدخال بريد إلكتروني صحيح.",
  suc_get_dialog_text:
    "បើកកម្មវិធីសមាជិក Haidilao ភ្លាមៗ ដើម្បីមើលគូប៉ុងដែលបានទទួល!",
  btn_sure: "អោយត្រូវ",
  btn_cancel: "លុបចោល",
  suc_dialog_text:
    "បើកកម្មវិធី Haidilao ឬភ្ជាប់សមាជិកនៅលើ LINE ដើម្បីមើលកូពុងដែលបានទទួល!",
  btn_return: "ត្រឡប់ក្រោយ",
  btn_download: "ទាញយក",
};
